export default __webpack_public_path__ + "static/media/AA Smartfuel Logo.987ec1cb.jpg";